import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText,
} from '@mui/material'
import { FieldValues, Path, PathValue, useController, UseControllerProps } from 'react-hook-form'

export type HookFormCheckboxProps<T extends FieldValues> = Omit<
  CheckboxProps,
  'name' | 'defaultValue' | 'checked' | 'onChange' | 'onBlur' | 'value'
> & {
  name: Path<T>
  label: FormControlLabelProps['label']
  helperText?: string
  defaultValue?: PathValue<T, Path<T>>
  control?: UseControllerProps<T>['control']
  formControlLabelProps?: Omit<FormControlLabelProps, 'control' | 'label'>
}

export function HookFormCheckbox<T extends FieldValues>({
  name,
  label,
  helperText,
  defaultValue,
  control,
  formControlLabelProps,
  ...props
}: HookFormCheckboxProps<T>) {
  const {
    field,
    fieldState: { error },
  } = useController<T>({ name, defaultValue, control })

  return (
    <>
      <FormControlLabel
        {...formControlLabelProps}
        label={label}
        control={
          <Checkbox {...props} {...field} checked={!!field.value} disabled={props.disabled} />
        }
      />
      {(error || helperText) && (
        <FormHelperText error={!!error} sx={{ mt: -0.5, ml: 4 }}>
          {error ? error.message : helperText}
        </FormHelperText>
      )}
    </>
  )
}
